<div style="display: flex">
  @if (cc.aidYearChanges | async; as aidYearChanges) {
    <button mat-icon-button matTooltip="Aid Year Changes" (click)="openDialog(aidYearChanges)">
      <mat-icon svgIcon="aid-year" aria-hidden="false" aria-label="Aid Year Changes"></mat-icon>
    </button>
  }
  <div class="aid-year">
    <mat-form-field style="width: 10rem" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Aid Year</mat-label>
      <mat-select [(value)]="selectedAidYear" (selectionChange)="selectionChange()" [disabled]="disabled">
        @for (option of aidYearOptions; track option) {
          <mat-option [value]="option.value" [disabled]="option.hide">{{ option.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
